import React from 'react';
import { Loader2 } from 'lucide-react';

export interface LoadingSpinnerProps {
  label?: string;
  size?: 'sm' | 'md' | 'lg';
  fullPage?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  label = 'Loading...',
  size = 'md',
  fullPage = false,
}) => {
  const pixelSizes = {
    sm: 18,
    md: 28,
    lg: 42,
  };

  const containerStyles: React.CSSProperties = fullPage
    ? {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '70vh',
        width: '100%',
        gap: '1rem',
        color: 'var(--text-secondary)',
      }
    : {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2.5rem 1rem',
        width: '100%',
        gap: '0.75rem',
        color: 'var(--text-secondary)',
      };

  return (
    <div
      style={containerStyles}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <Loader2
        size={pixelSizes[size]}
        style={{
          animation: 'spin 1s linear infinite',
          color: 'var(--accent-primary)',
        }}
      />
      {label && (
        <span
          style={{
            fontSize: size === 'sm' ? '0.8125rem' : size === 'lg' ? '1.125rem' : '0.9375rem',
            fontWeight: 500,
          }}
        >
          {label}
        </span>
      )}
    </div>
  );
};
